import { Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';

const FormSection = ({ title, children }: { title: string; children: React.ReactNode }) => {
    return (
        <Stack spacing={2}>
            <Typography variant='subtitle1' fontWeight={'bold'} color='primary'>
                {title}
            </Typography>
            <Grid2
                container
                spacing={2}
                sx={{
                    mx: '-8px !important',
                }}
            >
                {children}
            </Grid2>
        </Stack>
    );
};

export default FormSection;
